import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "NIISensitivityModeler" })(
  (_theme, toCompare) => ({
    page: {
      margin: "20px",
    },

    NIISensitivityModelerCardResponsive: {
      width: toCompare ? "48%" : "100%",
      [`@media (max-width:1060px)`]: {
        width: "100%",
      },
    },

    nIISensitivityModelerExportBtn: {
      display: "flex",
      justifyContent: "flex-end",
      marginRight: "10px",
      marginTop: "-30px",
    },
    SaveBtn: {
      display: "flex",
      justifyContent: "flex-end",
      marginRight: "10px",
      marginTop: "10px",
    },
  }),
);
